// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"503fe87d","154":"818f897f","213":"f3884522","455":"9b15ae9e","635":"1e22a77f","744":"5a4749e1","855":"4eb22f58","888":"387ee22a"}[chunkId] + ".chunk.js";
};